import { Config } from '../../config/config';
import { Img } from './img';
import { Publication } from './publication';

export class Metier extends Publication {

    
    secteur;
    niveau;
    salaire;
    alternance;
    selectivite;
    insertion;

    image_video: Img;

    video_link;

    constructor() {
        super();
        this.is_publish = true;
    }


    get urltmbVideo(): string {

        if( this.image_video !== undefined && this.image_video !== null && this.image_video.url !== null)
        return  Config.urlserveur + this.image_video.url; // return  Config.urlserveur + this.image_video.tmb;
        else
        return 'assets/images/noimage.png';
    }
    
    
   
  }